import { useTranslation } from "react-i18next";
import { AccessStatePage } from "../features/auth/AccessStatePage";
import { AuthProvider } from "../features/auth/AuthProvider";
import { LoginPage } from "../features/auth/LoginPage";
import { ResetPasswordPage } from "../features/auth/ResetPasswordPage";
import { useAuth } from "../features/auth/auth-context";
import { AuthenticatedShell } from "../features/shell/AuthenticatedShell";
import { NetworkStatusBanner } from "../features/shell/NetworkStatusBanner";

function AppContent() {
  const { t } = useTranslation();
  const { state } = useAuth();
  if (state.kind === "loading") return <main className="auth-page"><p role="status">{t("auth.loading")}</p></main>;
  if (state.kind === "signed_out") return <LoginPage />;
  if (state.kind === "recovery") return <ResetPasswordPage />;
  if (state.kind === "recovery_invalid") return <ResetPasswordPage invalid />;
  if (state.kind === "invited") return <AccessStatePage status="invited" access={state.access} />;
  if (state.kind === "disabled") return <AccessStatePage status="disabled" access={state.access} />;
  if (state.kind === "error") return <AccessStatePage status="error" />;
  return <AuthenticatedShell access={state.access} />;
}

export function App() {
  return <AuthProvider><NetworkStatusBanner/><AppContent /></AuthProvider>;
}
